module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-section cart-summary"
  }, [_c('div', {
    staticClass: "container pd-sm-0"
  }, [_c('h1', {
    staticClass: "header-title"
  }, [_vm._v("ตะกร้าของคุณ")]), _vm._v(" "), _vm._l((_vm.removedProducts), function(item) {
    return _c('undo-remove', {
      key: _vm.sku(item),
      attrs: {
        "product": item.product,
        "attributes": item.attributes,
        "quantity": item.quantity
      },
      on: {
        "undo": _vm.onUndo
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "with-sidebar"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "product-summary"
  }, [_c('div', {
    staticClass: "block-secondary block"
  }, [_c('cart-summary', {
    on: {
      "itemRemoved": _vm.itemRemoved
    }
  }), _vm._v(" "), (_vm.$utils.isCartEmpty()) ? _c('div', [_vm._v("\n              คุณยังไม่ได้เลือกรายการบริจาค\n              "), _c('router-link', {
    attrs: {
      "to": {
        name: 'products_list'
      }
    }
  }, [_vm._v("เลือกดูรายการของเรา")])], 1) : _vm._e(), _vm._v(" "), (_vm.buyMoreButton) ? _c('div', {
    staticClass: "product__action"
  }, [_c('a', {
    staticClass: "btn btn--white",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.gotoProductList()
      }
    }
  }, [_vm._v("เลือกรายการเพิ่ม")])]) : _vm._e()], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('delivery-selector', {
    staticClass: "show-sm"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sidebar-container hide-sm"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        triggerTop: 70,
        top: 70,
        triggerBottom: 70,
        bottom: 70
      }),
      expression: "{triggerTop: 70, top:70, triggerBottom: 70, bottom: 70}"
    }],
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "block block-secondary"
  }, [_c('h3', {
    staticClass: "sidebar__title"
  }, [_vm._v("รายการในตะกร้า "), _c('small', [_vm._v("(" + _vm._s(_vm.$utils.getCartItemCount()) + " รายการ)")])]), _vm._v(" "), _c('div', {
    staticClass: "summary__row--lg"
  }, [_c('span', {
    staticClass: "summary__label"
  }, [_vm._v("รวม")]), _vm._v(" "), _c('span', {
    staticClass: "summary__value"
  }, [_vm._v(_vm._s(_vm._f("comma")(_vm.$utils.getCartGrandTotalPrice())) + "  ฿")])]), _vm._v(" "), _c('delivery-selector'), _vm._v(" "), _c('a', {
    staticClass: "btn btn--purple ma-0",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.gotoCheckout()
      }
    }
  }, [_vm._v("ชำระเงิน")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sidebar sidebar-ghost"
  })])])], 2), _vm._v(" "), (_vm.checkoutButton) ? _c('div', {
    staticClass: "block-primary block show-sm"
  }, [_c('a', {
    staticClass: "btn btn--purple ma-0",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.gotoCheckout()
      }
    }
  }, [_vm._v("ชำระเงิน")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ff16ea1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cart.vue
// module id = 1136
// module chunks = 0